import React from 'react'
import Navbar from "../../components/Navbar/Navbar"
import Footer from  "../../components/Footer/Footer"
import VoyahCourageSpec from '../../components/VoyahCourageSpec/VoyahCourageSpec'
import Gallery from '../../components/Gallery/Gallery'

const VoyahCourageSpecifications = () => {
  return (
    <div className='vcgsopec'>
      <Navbar/>
      <VoyahCourageSpec/>
        <Gallery/>
      <Footer/>
    </div>
  )
}

export default VoyahCourageSpecifications
